import { withFeedback, FeedbackContainerProps } from "../../feedback";
import View, { DashboardProps as _DashboardProps } from "./dashboard-view";
export { ModalKeys } from "./dashboard-view";

export interface DashboardProps
  extends Omit<_DashboardProps, keyof FeedbackContainerProps> {}
export default withFeedback<DashboardProps & FeedbackContainerProps>(View);
